module.exports = __webpack_public_path__ + "static/media/walls-header@2x.d93255a4.jpg";